<template>
  <div class="content-wrapper">
    <section class="content container-fluid">
      <div class="row">
        <div
          class="col-md-3"
          v-if="currentUser"
        >
          <div class="box box-primary">
            <div
              class="box-body box-profile"
              v-viewer
            >
              <img
                class="profile-user-img img-responsive img-circle"
                :src="userAvatar"
                alt="User profile picture"
                @error="(e) => {e.target.src='/img/avatar.png'}"
              >
              <h3 class="profile-username text-center">
                {{ currentUser.name }}
              </h3>
              <p class="text-muted text-center">
                {{ currentUser.position }}
              </p>
              <ul class="list-group">
                <li class="list-group-item">
                  <strong><i class="fa fa-map-marker margin-r-5" /> {{ $t('label.location') }}</strong>
                  <p class="text-muted">
                    {{ currentUser.location }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-9">
          <router-view />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',
  data () {
    return {
      apiUrl: process.env.VUE_APP_API
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  }
}
</script>

<style scoped>

</style>
